export enum AssetUIMessages {
  SEARCH_ASSET_ERROR = 'An error occurred while searching Assets.',
  TOO_MANY_RESULTS = 'Too many results, please refine your search.',
  LOAD_SITES_ERROR = 'An error occurred while loading the Sites.',
  LOAD_CUSTOMERS_ERROR = 'An error occurred while loading the Customers.',
  LOAD_ASSET_ERROR = 'An error occurred while loading the Asset.',
  EDIT_ASSET_SUCCESS = 'Asset successfully updated.',
  EDIT_ASSET_ERROR = 'An error occurred while updating the Asset.',
  EDIT_ASSETS_SUCCESS = '{0} of {1} assets were updated',
  ADD_ASSET_SUCCESS = 'Asset successfully created.',
  ADD_ASSET_ERROR = 'An error occurred while creating the Asset.',
  SERIAL_NUMBER_INVALID = 'Invalid Serial Number, already exists.',
  SERIAL_NUMBER_ERROR = 'An error occurred while validating the Serial Number.',
  ACTIVATE_ASSET = 'Active Asset',
  ACTIVATE_ASSETS = 'Active Assets',
  ACTIVATE_ASSETS_SUCCESS = 'Assets successfully activated.',
  ACTIVATE_ASSETS_ERROR = 'An error occurred while activating the assets.',
  ACTIVATE_ASSET_SUCCESS = 'Asset successfully activated.',
  ACTIVATE_ASSET_ERROR = 'An error occurred while activating asset.',
  ACTIVATE_BULK_ASSETS_CONFIRMATION = 'Are you sure you want to activate {0} Assets ?',
  ACTIVATE_ASSET_CONFIRMATION = 'Are you sure you want to activate the Asset ?',
  DEACTIVATE_ASSET = 'Retire Asset',
  DEACTIVATE_ASSETS = 'Retire Assets',
  DEACTIVATE_ASSETS_SUCCESS = 'Assets successfully deactivated.',
  DEACTIVATE_ASSET_SUCCESS = 'Asset successfully deactivated.',
  DEACTIVATE_ASSET_ERROR = 'An error occurred while deactivating asset.',
  DEACTIVATE_ASSETS_ERROR = 'An error occurred while deactivating assets.',
  DEACTIVATE_BULK_ASSETS_CONFIRMATION = 'Are you sure you want to retire {0} Assets ?',
  DEACTIVATE_ASSET_CONFIRMATION = 'Are you sure you want to retire the Asset ?',
  DEACTIVATE_ASSET_ATTACHMENT_ERROR = 'An error occurred while create asset attachment.',
  DEACTIVATE_FILE_UPLOAD_ERROR = 'An error occurred while upload file in k8.',
  DEACTIVATE_FILE_EXTENSION_ERROR = 'This file extension not supported in asset.',
  DEACTIVATE_FILE_SIZE_ERROR = 'This file size limit exceeded.'
}
